import {
  BaseCellRenderer,
  createFromBaseCellRenderer,
  createIcon,
} from '@blocksuite/data-view';
import { css } from '@emotion/css';
import { baseTheme } from '@streamlain/theme';
import { format } from 'date-fns/format';
import { html } from 'lit';

import { createdTimePropertyModelConfig } from './define.js';

const createdTimeCellStyle = css({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  padding: '0',
  border: 'none',
  fontFamily: baseTheme.fontSansFamily,
  color: 'var(--streamlain-text-primary-color)',
  fontWeight: '400',
  backgroundColor: 'transparent',
  fontSize: 'var(--data-view-cell-text-size)',
  lineHeight: 'var(--data-view-cell-text-line-height)',
  height: 'var(--data-view-cell-text-line-height)',
});

export class CreatedTimeCell extends BaseCellRenderer<number, number> {
  override beforeEnterEditMode() {
    return false;
  }

  override render() {
    const value = this.value ? format(this.value, 'yyyy/MM/dd HH:mm') : '';
    return html`<div class="${createdTimeCellStyle}">${value}</div>`;
  }
}

export const createdTimeColumnConfig =
  createdTimePropertyModelConfig.createPropertyMeta({
    icon: createIcon('DateTimeIcon'),
    cellRenderer: {
      view: createFromBaseCellRenderer(CreatedTimeCell),
    },
  });
